/* tslint:disable */
/* eslint-disable */

/**
 * groupType
 */
export enum AreaGroupType {
  Group5X1 = 'GROUP_5x1',
  Group5X3 = 'GROUP_5x3',
  Group2X1 = 'GROUP_2x1',
  Group3X3 = 'GROUP_3x3',
  GroupSection1 = 'GROUP_SECTION_1',
  GroupSection2 = 'GROUP_SECTION_2',
  GroupSection5 = 'GROUP_SECTION_5'
}
